import { Component, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Site, SiteService } from '@shared/service/site.service';
import { SharedService } from '@shared/service/shared.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { LoginType } from '@shared/model/auth.models';

@Component({
  selector: 'fl-edit-login',
  templateUrl: './edit-login.component.html',
  styleUrl: './edit-login.component.scss',
  standalone: false,
})
export class EditLoginComponent implements OnInit {
  tabIndex: number = 0;

  isVisible: boolean = false;

  site: Site;

  bg: string;

  /**
   * 提供给裁剪的图片地址
   */
  cropImage: string;

  tabs = [
    {
      label: '默认模式',
      key: LoginType.Big,
    },
    {
      label: '小窗模式',
      key: LoginType.Small,
    },
  ];

  LoginType = LoginType;

  get siteTypeIndex() {
    return this.tabs.findIndex(x => x.key === this.sharedSrv.site.backgroundType);
  }

  private title = inject(Title);
  private siteSrv = inject(SiteService);
  public sharedSrv = inject(SharedService);
  private modalSrv = inject(NzModalService);
  private msgSrv = inject(NzMessageService);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  constructor() {
    this.title.setTitle('登录页设置');
  }

  ngOnInit() {
    this.loadData();
    if (this.sharedSrv.site.backgroundType) {
      this.tabIndex = this.tabs.findIndex(x => x.key === this.sharedSrv.site.backgroundType);
    }
  }

  onTabChange(i: number) {
    this.tabIndex = i;
  }

  changeModal() {
    this.isVisible = true;
    this.cropImage = this.bg;
  }

  handleOk() {}

  private async loadData() {
    this.site = await this.siteSrv.getSite();
    if (this.site.siteTitle.indexOf('智慧教学云') < 0) {
      this.site.siteTitle = `${this.site.siteTitle} | '智慧教学云'`;
    } else {
      this.site.siteTitle = this.site.siteTitle.split('|')[0] + ' | ' + '智慧教学云';
    }
    this.sharedSrv.site = this.site;

    if (this.site) {
      this.bg = this.site.newBackground || this.site.background;
    } else {
      this.bg = 'assets/image/common/background.jpg';
    }

    this.cropImage = this.bg;
    // OnPush：异步赋值后需主动标记，否则视图不刷新
    this.cdr.markForCheck();
  }

  async cropped(e: File) {
    const id = this.msgSrv.loading('正在设置登录页背景，请稍候...').messageId;
    const formData = new FormData();
    formData.append('newBackground', e);
    formData.append('backgroundType', this.tabs[this.tabIndex].key);
    try {
      const result = await this.siteSrv.setSitesBackground(this.site.id, formData);
      if (result) {
        this.loadData();
      }
      this.msgSrv.remove(id);
      this.msgSrv.success('设置成功');
    } catch (e) {
      this.msgSrv.remove(id);
      this.msgSrv.error('设置失败，请稍后重试');
    }
  }

  changeImage() {
    if (!this.site.background) {
      this.msgSrv.warning('未找到原图');
      return;
    }
    this.cropImage = this.site.background;
  }
}
